import {ExtranetPublicRoutes} from "./routing/ExtranetPublicRoutes";

export const publicRoutes = [
    ...ExtranetPublicRoutes
];